import { initializeApp } from 'firebase/app'
import { getAuth, connectAuthEmulator } from 'firebase/auth'
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore'
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions'
import { getDatabase, connectDatabaseEmulator } from 'firebase/database'
import { getStorage } from 'firebase/storage'

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  databaseURL: 'https://salewgknib-default-rtdb.firebaseio.com',
}

// Initialize Firebase
export const app = initializeApp(firebaseConfig)

// Initialize services
export const auth = getAuth(app)
export const db = getFirestore(app)
export const functions = getFunctions(app)
export const rtdb = getDatabase(app)
export const storage = getStorage(app)

// Set longer timeout for Cloud Functions (10 minutes)
functions.customDomain = null
// Note: Individual function timeouts are set in the service calls

// Connect to emulators in development
if (import.meta.env.VITE_USE_EMULATOR === 'true') {
  const emulatorHost = import.meta.env.VITE_EMULATOR_HOST || 'localhost'

  connectAuthEmulator(
    auth,
    `http://${emulatorHost}:${import.meta.env.VITE_EMULATOR_AUTH_PORT || 9099}`
  )

  connectFirestoreEmulator(
    db,
    emulatorHost,
    parseInt(import.meta.env.VITE_EMULATOR_FIRESTORE_PORT || '8080')
  )

  connectFunctionsEmulator(
    functions,
    emulatorHost,
    parseInt(import.meta.env.VITE_EMULATOR_FUNCTIONS_PORT || '5001')
  )

  connectDatabaseEmulator(
    rtdb,
    emulatorHost,
    parseInt(import.meta.env.VITE_EMULATOR_DATABASE_PORT || '9000')
  )

  console.log('🔧 Connected to Firebase Emulators')
}

export default app
